/**
 * SettingsPage - 設定画面コンポーネント
 */

import { useStore } from '../store'

export function SettingsPage() {
  const navigateTo = useStore(state => state.navigateTo)
  const clearAll = useStore(state => state.clearAll)

  const handleClearAll = () => {
    if (confirm('すべてのデータを削除しますか？この操作は取り消せません。')) {
      void clearAll()
      navigateTo('home')
    }
  }

  return (
    <div className="min-h-screen bg-gray-900 text-white">
      <div className="flex items-center justify-between p-4 bg-gray-800">
        <button
          onClick={() => navigateTo('home')}
          className="p-2 hover:bg-gray-700 rounded-lg transition-colors"
        >
          <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
          </svg>
        </button>
        <h2 className="text-lg font-semibold">設定</h2>
        <div className="w-10"></div>
      </div>
      
      <div className="p-4">
        <div className="bg-gray-800 rounded-lg p-4 mb-4">
          <h3 className="font-semibold mb-2">データ管理</h3>
          <button
            onClick={handleClearAll}
            className="w-full px-4 py-2 bg-red-600 hover:bg-red-700 rounded-lg transition-colors"
          >
            すべてのデータを削除
          </button>
        </div>
        
        <div className="bg-gray-800 rounded-lg p-4">
          <h3 className="font-semibold mb-2">バージョン情報</h3>
          <p className="text-sm text-gray-400">ParaParaView v2.0.0</p>
          <p className="text-sm text-gray-400">Graph Structure Edition</p>
        </div>
      </div>
    </div>
  )
}